import { SaveReportRequestParams, useFiltersStore } from '@/hooks'
import { useActiveManagementFiltersStore } from '../stores/useActiveManagementFiltersStore'
import { mapActiveManagementFiltersSaveParams } from '../utils/mapActiveManagementFiltersSaveParams'
import { useMemo } from 'react'

export const useActiveManagementFiltersSaveParams = () => {
    const activeActiveManagementFilters = useActiveManagementFiltersStore(
        (state) => state.activeFilters
    )

    const rootNode = useFiltersStore((state) => state.rootNode)

    const ActiveManagementFiltersParams: SaveReportRequestParams =
        useMemo(() => {
            const passedFilters = Object.assign(
                {},
                activeActiveManagementFilters
            )

            if (!passedFilters.node.length && rootNode) {
                passedFilters.node = [rootNode.nodeId]
            }

            return mapActiveManagementFiltersSaveParams(passedFilters)
        }, [activeActiveManagementFilters, rootNode])

    return ActiveManagementFiltersParams
}
